import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BASE_URL, USER_URL } from "../../constant/api";
import axios from "axios";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import ScaleLoader from "react-spinners/ScaleLoader"; // Import ScaleLoader
import { useAuth } from "../../context/AuthContext";
import { toast } from "react-toastify";
import SuccessPoP from "../../components/SuccessFullPopUp/SuccessPoP";

function SellerBanner() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null); // For delete confirmation
  const token = localStorage.getItem("token");
  const [popup, setPopup] = useState({
    visible: false,
    success: false,
    button: false,
    message: "",
    subMessage: "",
    showCloseIcon: false,
    Trybutton: false,
  });
  const { user } = useAuth();
  const fetchProducts = async () => {
    try {
      setLoading(true); // Start loading
      const response = await axios.get(
        `${BASE_URL}/products/seller/banners/`,
        {
          headers: { Authorization: `JWT ${token}` },
        },
      );
      if (response.data?.Data) {
        setProducts(response.data?.Data);
        console.log("Products:", response.data?.Data);
      }
    } catch (error) {
      console.error("Error fetching products:", error.message || error);
    } finally {
      setLoading(false); // Stop loading
    }
  };
  // Fetch products on component mount
  useEffect(() => {
    
    fetchProducts();
  }, [token]);

  // Handle delete confirmation
  const handleDelete = async () => {
    if (selectedProduct) {
      try {
        await USER_URL.delete(
          `/products/seller/banners/${selectedProduct.id}/`,
        );
        setProducts(products.filter((p) => p.id !== selectedProduct.id));
        setShowConfirm(false);
        setSelectedProduct(null);
      } catch (error) {
        console.error("Error deleting product:", error.message || error);
      }
    }
  };

  const payNow = async (id) => {
    try {
      const data = {
        payment_for: "banner", // sponsored, banner, special_offer
        object_id: id,
      };
      console.log("Payment Data:", data);

      const res = await USER_URL.post(
        "/orders/seller/promotion/razorpay/initiate/",
        data,
      );
      const { razorpay_order_id, amount } = res.data.payment;
      const { razorpay_key } = res.data;
      const customerOrderNumber = res.data.customer_order_number;
      // console.log(" Razorpay Order ID:", customerOrderNumber);

      console.log(" INIT RESPONSE", res.data);

      const options = {
        key: razorpay_key,
        currency: "INR",
        amount: amount,
        order_id: razorpay_order_id,
        name: "BricksnMix",
        description: "Service Payment",
        image: "/images/logo/icon_sg.png",
        handler: async function (response) {
          console.log("Payment Response:", response);
          const confirmData = {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
            // customer_order_number: customerOrderNumber,
          };
          console.log("💳 Payment Confirmation Data:", confirmData);

          const verify = await USER_URL.patch(
            "/orders/seller/promotion/razorpay/confirm/",
            confirmData,
          );
          console.log(" Payment Verification:", verify.data);
          if (verify.data.Status === "1") {
            setPopup({
              visible: true,
              success: true,
              button: true,
              showCloseIcon: false,
              message: "Payment Successful",
              // subMessage: "Order Placed Successfully",
            });
            toast.success("Payment Successful")
            fetchProducts(); // Refresh the product list after payment
          } else {
            // setPopup({
            //   visible: true,
            //   success: false,
            //   // button: true,
            //   showCloseIcon: false,
            //   message: "Payment Failed",
            //   subMessage: "Please try again",
            //   Trybutton: true,
            // });
            toast.error("Payment Failed");
          }
        },
        prefill: {
          name: user?.user_name || "User name",
          email: user?.email || "user@gmail.com",
          contact: "9999999999",
        },
        theme: {
          color: "#F37254",
        },
        modal: {
          ondismiss: function () {
            console.log(" Razorpay popup closed");
          },
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (err) {
      console.error(" Error in payNow:", err);
      // setPopup({
      //   visible: true,
      //   success: false,
      //   // button: true,
      //   showCloseIcon: false,
      //   message: "Payment Failed",
      //   subMessage: "Please try again",
      //   Trybutton: true,
      // });
    }
  };

  return (
    <div className="p-6">
      {/* Header with Add New Banner Button */}
      <div className="m-5 flex items-center justify-end">
        <Link
          to="/seller/offerbrand/addbanner"
          className="rounded-lg bg-green-600 px-6 py-2 font-medium text-white shadow hover:bg-green-700"
        >
          + Add New Banner
        </Link>
      </div>

      {/* Loading Spinner */}
      {loading ? (
        <div className="flex h-64 items-center justify-center">
          <ScaleLoader color="#FFAE00" height={40} />
        </div>
      ) : (
        <div className="mt-4 overflow-auto">
          <table className="min-w-full text-center">
            <thead>
              <tr>
                <th className="text-md py-2 font-bold text-green-500">
                  Item No
                </th>
                <th className="text-md px-2 py-2 font-bold text-green-500">
                  Banner Name
                </th>
                <th className="text-md px-2 py-2 font-bold text-green-500">
                  Start Date
                </th>
                <th className="text-md px-2 py-2 font-bold text-green-500">
                  Status
                </th>
                {/* <th className="px-2 py-2 text-green-500 text-md font-bold">Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {products.length > 0 ? (
                products.map((product, index) => (
                  <tr key={product.id}>
                    <td className="px-3 py-3 text-sm">
                      <div className="rounded-lg border border-gray-300 py-2 text-gray-800">
                        {index + 1}
                      </div>
                    </td>
                    <td className="px-2 py-3 text-sm">
                      <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800">
                        {product.title || "Name"}
                      </div>
                    </td>
                    <td className="px-2 py-3 text-sm">
                    <div className="rounded-xl border p-2 text-center">
                                    {new Date(product.start_date).toLocaleDateString("en-GB")}
                                </div>
                    </td>
                    <td className="px-2 py-3 text-sm">
                      <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800">
                        {product.status || "P"}
                      </div>
                    </td>

                    {/* Action Buttons Row */}
                    <td className="px-4 py-3 text-sm">
                      <div className="flex gap-5">
                        {/* Pay Button */}
                        <button
                          onClick={() => payNow(product.id)}
                          disabled={product.payment_status !== "Pending"}
                          className={`flex flex-1 items-center justify-center rounded-lg px-2 py-2 text-center text-xs font-medium shadow-md transition sm:text-sm ${
                            product.payment_status === "Pending"
                              ? "border border-yellow-600 text-yellow-600 hover:border-yellow-700 hover:bg-yellow-700 hover:text-white"
                              : product.payment_status === "Completed"
                                ? "cursor-not-allowed border border-gray-400 bg-gray-100 text-gray-500"
                                : product.payment_status === "Failed"
                                  ? "cursor-not-allowed border border-red-400 bg-red-100 text-red-500"
                                  : "border border-gray-300 bg-gray-100 text-gray-500"
                          } `}
                        >
                          {product.payment_status === "Pending"
                            ? "Pay"
                            : product.payment_status === "Completed"
                              ? "Paid"
                              : product.payment_status === "Failed"
                                ? "Failed"
                                : "Unknown"}
                        </button>
                        {/* Edit Button */}
                        <Link
                          to={`/seller/offer/banner/edit/${product.id}`}
                          className="flex flex-1 items-center justify-center rounded-lg border border-blue-600 px-2 py-2 text-center text-xs font-medium text-blue-600 shadow-md transition hover:border-blue-700 hover:bg-blue-700 hover:text-white sm:text-sm"
                        >
                          Edit
                        </Link>

                        

                        {/* View Button */}
                        <Link
                          to={`/seller/offer/banner/view/${product.id}`}
                          className="flex flex-1 items-center justify-center rounded-lg border border-green-600 px-2 py-2 text-center text-xs font-medium text-green-600 shadow-md transition hover:border-green-700 hover:bg-green-700 hover:text-white sm:text-sm"
                        >
                          View
                        </Link>
                        {/* Delete Button */}
                        <button
                          className="flex flex-1 items-center justify-center rounded-lg border border-red-600 px-2 py-2 text-center text-xs font-medium text-red-600 shadow-md transition hover:border-red-700 hover:bg-red-700 hover:text-white sm:text-sm"
                          onClick={() => {
                            setSelectedProduct(product);
                            setShowConfirm(true);
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="py-4 text-center text-gray-600">
                    No banners found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showConfirm && (
        <DeleteModal
          entityName="banner"
          title={selectedProduct?.title}
          onConfirm={handleDelete}
          onCancel={() => setShowConfirm(false)}
        />
      )}
      
            {/* {popup.visible && (
              // <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform  shadow-md w-fit h-fit rounded-lg  ">
              <div className="fixed inset-0 flex h-full w-full items-center justify-center bg-black bg-opacity-50">
                <SuccessPoP
                  message={popup.message}
                  status={popup.success}
                  button={popup.button}
                  subMessage={popup.subMessage}
                  showCloseIcon={popup.showCloseIcon}
                  onClose={() => setPopup({ visible: false, success: false })}
                  redirectPath="/"
                  setPopup={setPopup}
                  Trybutton={popup.Trybutton}
                />
              </div>
            )} */}
    </div>
  );
}

export default SellerBanner;
